// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `video.lock-seek::-webkit-media-controls-timeline,
video.lock-seek::-webkit-media-controls-timeline-container,
video.lock-seek::-webkit-media-controls-current-time-display,
video.lock-seek::-webkit-media-controls-time-remaining-display,
video.lock-seek::-webkit-media-controls-seek-back-button,
video.lock-seek::-webkit-media-controls-seek-forward-button,
video.lock-seek::-webkit-media-controls-rewind-button,
video.lock-seek::-webkit-media-controls-fast-forward-button {
  display: none !important;
  pointer-events: none !important;
  -webkit-appearance: none !important;
}

.native-video-wrap {
  position: relative;
  width: 100%;
}
.native-video-wrap .locked-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  padding: 4px 8px;
  background: #000;
  border-radius: 8px;
}
.native-video-wrap .locked-controls .locked-play-btn {
  --color: #fff;
  margin: 0;
  height: 40px;
}
.native-video-wrap .locked-controls .locked-note {
  color: #fff;
  font-size: 13px;
  opacity: 0.85;
}

.camera-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 8px 0 12px;
}

.camera-container {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  text-align: center;
}
.camera-container p {
  font-size: 13px;
  line-height: 1.4;
  margin: 0 0 8px;
  color: #5e5d59;
}
.camera-container .video-feed {
  width: 100%;
  max-width: 250px;
  aspect-ratio: 5/4;
  height: auto;
  margin: 0 auto;
  display: block;
  border-radius: 8px;
  background: #000;
  object-fit: cover;
  transform: scaleX(-1);
}
.camera-container .video-overlay {
  display: none;
}
.camera-container .status-panel {
  margin-top: 8px;
}
.camera-container .status-panel .status-item p {
  font-size: 12px;
  line-height: 1.4;
  margin: 0;
  color: #c0392b;
}
.camera-container .status-panel .status-item p span {
  font-weight: 700;
}

.provider-select {
  --padding-start: 0;
  --padding-end: 0;
  --inner-padding-end: 0;
  --background: transparent;
  width: 100%;
  margin-bottom: 8px;
}
.provider-select ion-label {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px 0;
  max-width: 100%;
  white-space: normal;
}
.provider-select ion-select {
  width: 100%;
  max-width: 100%;
  --padding-start: 10px;
  --padding-end: 10px;
  font-size: 14px;
  border: 1px solid #d7d7d7;
  border-radius: 8px;
  background: #fff;
  min-height: 42px;
}
.provider-select ion-select::part(text) {
  white-space: normal;
}

.provider-hint {
  font-size: 13px;
  color: #c0392b;
  margin: 4px 0 12px;
}

@media (max-width: 540px) {
  .camera-container {
    max-width: 280px;
  }
  .camera-container .video-feed {
    max-width: 220px;
  }
  .native-video-wrap .locked-controls {
    flex-wrap: wrap;
  }
  .native-video-wrap .locked-controls .locked-note {
    font-size: 12px;
  }
}
@media (min-width: 768px) {
  .camera-section {
    margin: 16px 0 20px;
  }
  .camera-container {
    max-width: 360px;
  }
  .camera-container p {
    font-size: 14px;
  }
  .camera-container .video-feed {
    max-width: 280px;
  }
  .camera-container .status-panel .status-item p {
    font-size: 13px;
  }
  .provider-select {
    width: 100%;
    max-width: 480px;
  }
  .provider-select ion-label {
    font-size: 15px;
  }
  .provider-select ion-select {
    font-size: 15px;
  }
  .provider-hint {
    font-size: 14px;
  }
  .native-video-wrap .locked-controls {
    padding: 6px 12px;
  }
  .native-video-wrap .locked-controls .locked-note {
    font-size: 14px;
  }
}
@media (max-width: 540px) {
  .menu ion-icon {
    font-size: 10vw;
    cursor: pointer;
    color: #414042;
  }
  h1 {
    font-size: 7vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: left;
  }
  h3 {
    font-size: 4vw;
    margin: 0vw;
    margin-bottom: 0vw;
  }
  .faq {
    background-color: #f0f6f9;
    background-image: url('bridge.svg');
    background-position: top center;
    background-repeat: repeat-y;
    background-size: 50%;
  }
  .faq h1 {
    font-size: 8vw;
    color: #292822;
    font-family: "Otomanopee One", sans-serif;
    margin-top: 10vw;
    text-align: center;
  }
  .faq p {
    font-size: 4vw;
    color: #5e5d59;
    line-height: 28px;
    text-align: center;
  }
  .accordion {
    background-color: white;
    margin-bottom: 4vw;
    border: 1px solid #e3e3e3;
  }
  .accordionHeader {
    background-color: white;
    overflow: hidden;
  }
  .accordionHeader h1 {
    margin: 0px;
    padding: 4vw;
    font-size: 5vw;
    width: 100%;
    float: left;
    text-align: left;
  }
  .accordionHeader a {
    float: right;
  }
  .accordionBody p {
    margin: 0px;
    padding-top: 2vw;
    padding-bottom: 4vw;
    padding-left: 4vw;
    padding-right: 4vw;
    font-size: 4vw;
    width: 100%;
  }
}
@media (min-width: 720px) {
  .menu ion-icon {
    font-size: 8vw;
    cursor: pointer;
    color: #414042;
  }
  h1 {
    font-size: 4vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: left;
  }
  h3 {
    font-size: 3vw;
    margin: 0vw;
    margin-bottom: 0vw;
  }
  .faq {
    background-color: #f0f6f9;
    background-image: url('bridge.svg');
    background-position: top center;
    background-repeat: repeat-y;
    background-size: 50%;
  }
  .faq h1 {
    font-size: 8vw;
    color: #292822;
    font-family: "Otomanopee One", sans-serif;
    margin-top: 10vw;
    text-align: center;
  }
  .faq p {
    font-size: 4vw;
    color: #5e5d59;
    line-height: 28px;
    text-align: center;
  }
  .accordion {
    background-color: white;
    margin-bottom: 4vw;
    border: 1px solid #e3e3e3;
  }
  .accordionHeader {
    background-color: white;
    overflow: hidden;
  }
  .accordionHeader h1 {
    margin: 0px;
    padding: 4vw;
    font-size: 5vw;
    width: 100%;
    float: left;
    text-align: left;
  }
  .accordionHeader a {
    float: right;
  }
  .accordionBody p {
    margin: 0px;
    padding-top: 2vw;
    padding-bottom: 4vw;
    padding-left: 4vw;
    padding-right: 4vw;
    width: 100%;
    font-size: 3vw;
    text-align: left;
    line-height: 3.5vw;
  }
}
@media (min-width: 960px) {
  .logo {
    width: 133px;
    height: 72px;
    background-image: url('logo.svg');
    background-size: 100%;
  }
  .menu ion-icon {
    font-size: 2vw;
    cursor: pointer;
    color: #414042;
  }
  h1 {
    font-size: 2vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: left;
  }
  h3 {
    font-size: 1vw;
    margin: 0vw;
    margin-bottom: 0vw;
  }
  .faq {
    background-color: #f0f6f9;
    background-image: url('bridge.svg');
    background-position: top center;
    background-repeat: repeat-y;
  }
  .faq h1 {
    font-size: 3vw;
    color: #292822;
    font-family: "Otomanopee One", sans-serif;
    margin-top: 5vw;
  }
  .faq p {
    font-size: 1vw;
    color: #5e5d59;
  }
  .accordion {
    background-color: white;
    margin-bottom: 1vw;
    border: 1px solid #e3e3e3;
  }
  .accordionHeader {
    background-color: white;
    overflow: hidden;
  }
  .accordionHeader h1 {
    margin: 0px;
    padding: 1vw;
    font-size: 1.5vw;
    width: 100%;
    float: left;
  }
  .accordionHeader a {
    float: right;
  }
  .accordionBody p {
    margin: 0px;
    padding-top: 0.5vw;
    padding-bottom: 1vw;
    padding-left: 1vw;
    padding-right: 1vw;
    font-size: 1vw;
    width: 100%;
    line-height: 1.2vw;
  }
}
.bg {
  background-image: url('student-bg.svg');
  background-repeat: no-repeat;
  background-color: #f0f6f9;
  background-position-y: bottom;
  padding-bottom: 5vw;
}

ion-content {
  --ion-background-color: #fff;
}

.content {
  background-color: white;
  background-image: url('student-bg-bottom.svg');
  background-repeat: no-repeat;
  background-position: center bottom;
  border-top-left-radius: 1vw;
  border-top-right-radius: 1vw;
  margin-top: -1vw;
  min-height: 100vh;
}

.toDoListTitle {
  color: #0038a8;
  font-family: "Otomanopee One", sans-serif;
}

.ion-padding-bottom {
  padding-bottom: 200px;
}

.backCaption {
  text-decoration: none;
  cursor: pointer;
}

.reloadBtn {
  text-decoration: none;
  float: right;
}

.nextTopic {
  text-decoration: none;
  cursor: pointer;
  float: right;
  text-align: right;
}

.prevTopic {
  text-decoration: none;
  cursor: pointer;
  float: left;
  text-align: left;
}

h2 {
  font-family: "Otomanopee One", sans-serif;
}

h3 {
  color: #5e5d59;
  font-family: "Otomanopee One", sans-serif;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

#myVideo {
  width: 100%;
  max-width: 100%;
}
#myVideo iframe {
  width: 100% !important;
  max-width: 100% !important;
  aspect-ratio: 16/9;
  height: auto !important;
  border-radius: 8px;
  display: block;
}

.native-video-wrap video#nativeVideoPlayer {
  aspect-ratio: 16/9;
  height: auto;
}

[innerHTML] img,
[innerHTML] iframe,
[innerHTML] video,
[innerHTML] table,
.content img,
.content iframe,
.content video,
.content table {
  max-width: 100%;
  height: auto;
}

ion-button {
  --border-radius: 8px;
}

.navigation-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}
.navigation-buttons .nav-btn {
  margin: 0;
}
.navigation-buttons .nav-btn-next {
  margin-left: auto;
}

@media (max-width: 575px) {
  .content ion-grid {
    padding-left: 6px;
    padding-right: 6px;
  }
  .navigation-buttons {
    flex-direction: column;
    align-items: stretch;
  }
  .navigation-buttons .nav-btn {
    width: 100%;
    margin-left: 0;
  }
  ion-card.ion-padding {
    margin-left: 0;
    margin-right: 0;
  }
  h1 {
    word-break: break-word;
  }
}
@media (min-width: 768px) {
  #myVideo iframe,
  .native-video-wrap video#nativeVideoPlayer {
    max-width: 720px;
    margin: 0 auto;
  }
}
@media (min-width: 1200px) {
  #myVideo iframe,
  .native-video-wrap video#nativeVideoPlayer {
    max-width: 820px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/student/module-progress-detail/module-progress-detail.page.scss"],"names":[],"mappings":"AAMA;;;;;;;;EAQE,wBAAA;EACA,+BAAA;EACA,mCAAA;AALF;;AAYA;EACE,kBAAA;EACA,WAAA;AATF;AAWE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AATJ;AAWI;EACE,aAAA;EACA,SAAA;EACA,YAAA;AATN;AAYI;EACE,WAAA;EACA,eAAA;EACA,aAAA;AAVN;;AAqBA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAlBF;AAoBE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAnBJ;AAsBE;EACE,aAAA;AApBJ;AAuBE;EACE,eAAA;AArBJ;AAuBI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AArBN;AAuBM;EACE,gBAAA;AArBR;;AA4BA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AAzBF;AA2BE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA1BJ;AA8BE;EACE,mBAAA;AA5BJ;;AAgCA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE;IACE,gBAAA;EA7BF;EA+BE;IACE,gBAAA;EA7BJ;EAkCE;IACE,eAAA;EAhCJ;EAkCI;IACE,eAAA;EAhCN;AACF;AAwCA;EACE;IACE,mBAAA;EAtCF;EAyCA;IACE,gBAAA;EAvCF;EAyCE;IACE,eAAA;EAvCJ;EA0CE;IACE,gBAAA;EAxCJ;EA2CE;IACE,eAAA;EAzCJ;EA8CA;IACE,WAAA;IACA,gBAAA;EA5CF;EA8CE;IACE,eAAA;EA5CJ;EA+CE;IACE,eAAA;EA7CJ;EAiDA;IACE,eAAA;EA/CF;EAmDE;IACE,iBAAA;EAjDJ;EAmDI;IACE,eAAA;EAjDN;AACF;AAsDA;EACE;IACE,eAAA;IACA,eAAA;IACA,cAAA;EApDF;EAsDA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,gBAAA;EApDF;EAuDA;IACE,cAAA;IACA,WAAA;IACA,kBAAA;EArDF;EAwDA;IACE,yBAAA;IACA,mCAAA;IACA,+BAAA;IACA,2BAAA;IACA,oBAAA;EAtDF;EAyDA;IACE,cAAA;IACA,cAAA;IACA,yCAAA;IACA,gBAAA;IACA,kBAAA;EAvDF;EA0DA;IACE,cAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;EAxDF;EA2DA;IACE,uBAAA;IACA,kBAAA;IACA,yBAAA;EAzDF;EA4DA;IACE,uBAAA;IACA,gBAAA;EA1DF;EA6DA;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;EA3DF;EA8DA;IACE,YAAA;EA5DF;EA+DA;IACE,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,cAAA;IACA,WAAA;EA7DF;AACF;AAgEA;EACE;IACE,cAAA;IACA,eAAA;IACA,cAAA;EA9DF;EAgEA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,gBAAA;EA9DF;EAgEA;IACE,cAAA;IACA,WAAA;IACA,kBAAA;EA9DF;EAgEA;IACE,yBAAA;IACA,mCAAA;IACA,+BAAA;IACA,2BAAA;IACA,oBAAA;EA9DF;EAiEA;IACE,cAAA;IACA,cAAA;IACA,yCAAA;IACA,gBAAA;IACA,kBAAA;EA/DF;EAkEA;IACE,cAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;EAhEF;EAmEA;IACE,uBAAA;IACA,kBAAA;IACA,yBAAA;EAjEF;EAoEA;IACE,uBAAA;IACA,gBAAA;EAlEF;EAqEA;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;EAnEF;EAsEA;IACE,YAAA;EApEF;EAuEA;IACE,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;IACA,gBAAA;IACA,kBAAA;EArEF;AACF;AAwEA;EACE;IACE,YAAA;IACA,YAAA;IACA,iCAAA;IACA,qBAAA;EAtEF;EAyEA;IACE,cAAA;IACA,eAAA;IACA,cAAA;EAvEF;EAyEA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,gBAAA;EAvEF;EAyEA;IACE,cAAA;IACA,WAAA;IACA,kBAAA;EAvEF;EAyEA;IACE,yBAAA;IACA,mCAAA;IACA,+BAAA;IACA,2BAAA;EAvEF;EA0EA;IACE,cAAA;IACA,cAAA;IACA,yCAAA;IACA,eAAA;EAxEF;EA2EA;IACE,cAAA;IACA,cAAA;EAzEF;EA4EA;IACE,uBAAA;IACA,kBAAA;IACA,yBAAA;EA1EF;EA6EA;IACE,uBAAA;IACA,gBAAA;EA3EF;EA8EA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;EA5EF;EA+EA;IACE,YAAA;EA7EF;EAgFA;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,cAAA;IACA,WAAA;IACA,kBAAA;EA9EF;AACF;AAgFA;EACE,uCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AA9EF;;AAiFA;EACE,4BAAA;AA9EF;;AAgFA;EACE,uBAAA;EACA,8CAAA;EACA,4BAAA;EACA,kCAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;AA7EF;;AAgFA;EACE,cAAA;EACA,yCAAA;AA7EF;;AAgFA;EACE,qBAAA;AA7EF;;AAgFA;EACE,qBAAA;EACA,eAAA;AA7EF;;AAgFA;EACE,qBAAA;EACA,YAAA;AA7EF;;AAgFA;EACE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AA7EF;;AAgFA;EACE,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AA7EF;;AAgFA;EACE,yCAAA;AA7EF;;AAgFA;EACE,cAAA;EACA,yCAAA;AA7EF;;AAgFA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,wCAAA;AA7EF;;AAwFA;EACE,WAAA;EACA,eAAA;AArFF;AAuFE;EACE,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AArFJ;;AA4FE;EACE,kBAAA;EACA,YAAA;AAzFJ;;AAiGE;;;;;;;;EAIE,eAAA;EACA,YAAA;AA1FJ;;AAgGA;EACE,oBAAA;AA7FF;;AAmGA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;AAhGF;AAkGE;EACE,SAAA;AAhGJ;AAoGE;EACE,iBAAA;AAlGJ;;AAuGA;EACE;IACE,iBAAA;IACA,kBAAA;EApGF;EAwGA;IACE,sBAAA;IACA,oBAAA;EAtGF;EAwGE;IACE,WAAA;IACA,cAAA;EAtGJ;EA2GA;IACE,cAAA;IACA,eAAA;EAzGF;EA4GA;IACE,sBAAA;EA1GF;AACF;AA8GA;EACE;;IAEE,gBAAA;IACA,cAAA;EA5GF;AACF;AAgHA;EACE;;IAEE,gBAAA;EA9GF;AACF","sourcesContent":["// Disable the seek bar for native (Mux / Bunny) players until the video has\r\n// been fully watched. The visual hide below covers Chromium/WebKit engines\r\n// (Chrome, Edge, Safari, Android System WebView, iOS WKWebView). Firefox does\r\n// not expose stylable media-control pseudo-elements, so on Firefox (and as a\r\n// universal safety net everywhere) forward seeking is also blocked in JS via\r\n// the enforceSeekCap() guard in the component.\r\nvideo.lock-seek::-webkit-media-controls-timeline,\r\nvideo.lock-seek::-webkit-media-controls-timeline-container,\r\nvideo.lock-seek::-webkit-media-controls-current-time-display,\r\nvideo.lock-seek::-webkit-media-controls-time-remaining-display,\r\nvideo.lock-seek::-webkit-media-controls-seek-back-button,\r\nvideo.lock-seek::-webkit-media-controls-seek-forward-button,\r\nvideo.lock-seek::-webkit-media-controls-rewind-button,\r\nvideo.lock-seek::-webkit-media-controls-fast-forward-button {\r\n  display: none !important;\r\n  pointer-events: none !important;\r\n  -webkit-appearance: none !important;\r\n}\r\n\r\n// Custom locked-state player (used on Mux / Bunny while not yet watched). The\r\n// native controls attribute is removed in this state so there is NO seek bar on\r\n// any device (Android Chrome / iOS Safari included); these styles drive the\r\n// minimal custom play/pause bar shown instead.\r\n.native-video-wrap {\r\n  position: relative;\r\n  width: 100%;\r\n\r\n  .locked-controls {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin-top: 6px;\r\n    padding: 4px 8px;\r\n    background: #000;\r\n    border-radius: 8px;\r\n\r\n    .locked-play-btn {\r\n      --color: #fff;\r\n      margin: 0;\r\n      height: 40px;\r\n    }\r\n\r\n    .locked-note {\r\n      color: #fff;\r\n      font-size: 13px;\r\n      opacity: 0.85;\r\n    }\r\n  }\r\n}\r\n\r\n// ---------------------------------------------------------------------------\r\n// Camera / face-detection monitor + video provider controls (responsive)\r\n// These elements had no styling, which caused cramped spacing and misaligned\r\n// content on phones. The rules below keep them centered, spaced and properly\r\n// sized on Android and iOS.\r\n// ---------------------------------------------------------------------------\r\n.camera-section {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 8px 0 12px;\r\n}\r\n\r\n.camera-container {\r\n  width: 100%;\r\n  max-width: 320px;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n\r\n  p {\r\n    font-size: 13px;\r\n    line-height: 1.4;\r\n    margin: 0 0 8px;\r\n    color: #5e5d59;\r\n  }\r\n\r\n  .video-feed {\r\n    width: 100%;\r\n    max-width: 250px;\r\n    aspect-ratio: 5 / 4;\r\n    height: auto;\r\n    margin: 0 auto;\r\n    display: block;\r\n    border-radius: 8px;\r\n    background: #000;\r\n    object-fit: cover;\r\n    transform: scaleX(-1); // mirror selfie view\r\n  }\r\n\r\n  .video-overlay {\r\n    display: none; // overlay canvas not shown to the student\r\n  }\r\n\r\n  .status-panel {\r\n    margin-top: 8px;\r\n\r\n    .status-item p {\r\n      font-size: 12px;\r\n      line-height: 1.4;\r\n      margin: 0;\r\n      color: #c0392b;\r\n\r\n      span {\r\n        font-weight: 700;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Video stream source selector + hint\r\n.provider-select {\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n  --inner-padding-end: 0;\r\n  --background: transparent;\r\n  width: 100%;\r\n  margin-bottom: 8px;\r\n\r\n  ion-label {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    margin: 0 0 4px 0;\r\n    max-width: 100%;\r\n    white-space: normal;\r\n  }\r\n\r\n  ion-select {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    --padding-start: 10px;\r\n    --padding-end: 10px;\r\n    font-size: 14px;\r\n    border: 1px solid #d7d7d7;\r\n    border-radius: 8px;\r\n    background: #fff;\r\n    min-height: 42px;\r\n  }\r\n\r\n  // Keep the selected text from being clipped.\r\n  ion-select::part(text) {\r\n    white-space: normal;\r\n  }\r\n}\r\n\r\n.provider-hint {\r\n  font-size: 13px;\r\n  color: #c0392b;\r\n  margin: 4px 0 12px;\r\n}\r\n\r\n@media (max-width: 540px) {\r\n  .camera-container {\r\n    max-width: 280px;\r\n\r\n    .video-feed {\r\n      max-width: 220px;\r\n    }\r\n  }\r\n\r\n  .native-video-wrap {\r\n    .locked-controls {\r\n      flex-wrap: wrap;\r\n\r\n      .locked-note {\r\n        font-size: 12px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Desktop / large screens: give the monitor and controls more breathing room,\r\n// keep them centered within the content column and prevent the camera preview\r\n// from looking oversized.\r\n@media (min-width: 768px) {\r\n  .camera-section {\r\n    margin: 16px 0 20px;\r\n  }\r\n\r\n  .camera-container {\r\n    max-width: 360px;\r\n\r\n    p {\r\n      font-size: 14px;\r\n    }\r\n\r\n    .video-feed {\r\n      max-width: 280px;\r\n    }\r\n\r\n    .status-panel .status-item p {\r\n      font-size: 13px;\r\n    }\r\n  }\r\n\r\n  // On tablets/desktops keep the dropdown a comfortable, capped width.\r\n  .provider-select {\r\n    width: 100%;\r\n    max-width: 480px;\r\n\r\n    ion-label {\r\n      font-size: 15px;\r\n    }\r\n\r\n    ion-select {\r\n      font-size: 15px;\r\n    }\r\n  }\r\n\r\n  .provider-hint {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .native-video-wrap {\r\n    .locked-controls {\r\n      padding: 6px 12px;\r\n\r\n      .locked-note {\r\n        font-size: 14px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 540px) {\r\n  .menu ion-icon {\r\n    font-size: 10vw;\r\n    cursor: pointer;\r\n    color: #414042;\r\n  }\r\n  h1 {\r\n    font-size: 7vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: left;\r\n  }\r\n\r\n  h3 {\r\n    font-size: 4vw;\r\n    margin: 0vw;\r\n    margin-bottom: 0vw;\r\n  }\r\n\r\n  .faq {\r\n    background-color: #f0f6f9;\r\n    background-image: url(\"../../../../assets/img/layout/bridge.svg\");\r\n    background-position: top center;\r\n    background-repeat: repeat-y;\r\n    background-size: 50%;\r\n  }\r\n\r\n  .faq h1 {\r\n    font-size: 8vw;\r\n    color: #292822;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    margin-top: 10vw;\r\n    text-align: center;\r\n  }\r\n\r\n  .faq p {\r\n    font-size: 4vw;\r\n    color: #5e5d59;\r\n    line-height: 28px;\r\n    text-align: center;\r\n  }\r\n\r\n  .accordion {\r\n    background-color: white;\r\n    margin-bottom: 4vw;\r\n    border: 1px solid #e3e3e3;\r\n  }\r\n\r\n  .accordionHeader {\r\n    background-color: white;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .accordionHeader h1 {\r\n    margin: 0px;\r\n    padding: 4vw;\r\n    font-size: 5vw;\r\n    width: 100%;\r\n    float: left;\r\n    text-align: left;\r\n  }\r\n\r\n  .accordionHeader a {\r\n    float: right;\r\n  }\r\n\r\n  .accordionBody p {\r\n    margin: 0px;\r\n    padding-top: 2vw;\r\n    padding-bottom: 4vw;\r\n    padding-left: 4vw;\r\n    padding-right: 4vw;\r\n    font-size: 4vw;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (min-width: 720px) {\r\n  .menu ion-icon {\r\n    font-size: 8vw;\r\n    cursor: pointer;\r\n    color: #414042;\r\n  }\r\n  h1 {\r\n    font-size: 4vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: left;\r\n  }\r\n  h3 {\r\n    font-size: 3vw;\r\n    margin: 0vw;\r\n    margin-bottom: 0vw;\r\n  }\r\n  .faq {\r\n    background-color: #f0f6f9;\r\n    background-image: url(\"../../../../assets/img/layout/bridge.svg\");\r\n    background-position: top center;\r\n    background-repeat: repeat-y;\r\n    background-size: 50%;\r\n  }\r\n\r\n  .faq h1 {\r\n    font-size: 8vw;\r\n    color: #292822;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    margin-top: 10vw;\r\n    text-align: center;\r\n  }\r\n\r\n  .faq p {\r\n    font-size: 4vw;\r\n    color: #5e5d59;\r\n    line-height: 28px;\r\n    text-align: center;\r\n  }\r\n\r\n  .accordion {\r\n    background-color: white;\r\n    margin-bottom: 4vw;\r\n    border: 1px solid #e3e3e3;\r\n  }\r\n\r\n  .accordionHeader {\r\n    background-color: white;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .accordionHeader h1 {\r\n    margin: 0px;\r\n    padding: 4vw;\r\n    font-size: 5vw;\r\n    width: 100%;\r\n    float: left;\r\n    text-align: left;\r\n  }\r\n\r\n  .accordionHeader a {\r\n    float: right;\r\n  }\r\n\r\n  .accordionBody p {\r\n    margin: 0px;\r\n    padding-top: 2vw;\r\n    padding-bottom: 4vw;\r\n    padding-left: 4vw;\r\n    padding-right: 4vw;\r\n    width: 100%;\r\n    font-size: 3vw;\r\n    text-align: left;\r\n    line-height: 3.5vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 960px) {\r\n  .logo {\r\n    width: 133px;\r\n    height: 72px;\r\n    background-image: url(\"../../../../assets/img/layout/logo.svg\");\r\n    background-size: 100%;\r\n  }\r\n\r\n  .menu ion-icon {\r\n    font-size: 2vw;\r\n    cursor: pointer;\r\n    color: #414042;\r\n  }\r\n  h1 {\r\n    font-size: 2vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: left;\r\n  }\r\n  h3 {\r\n    font-size: 1vw;\r\n    margin: 0vw;\r\n    margin-bottom: 0vw;\r\n  }\r\n  .faq {\r\n    background-color: #f0f6f9;\r\n    background-image: url(\"../../../../assets/img/layout/bridge.svg\");\r\n    background-position: top center;\r\n    background-repeat: repeat-y;\r\n  }\r\n\r\n  .faq h1 {\r\n    font-size: 3vw;\r\n    color: #292822;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    margin-top: 5vw;\r\n  }\r\n\r\n  .faq p {\r\n    font-size: 1vw;\r\n    color: #5e5d59;\r\n  }\r\n\r\n  .accordion {\r\n    background-color: white;\r\n    margin-bottom: 1vw;\r\n    border: 1px solid #e3e3e3;\r\n  }\r\n\r\n  .accordionHeader {\r\n    background-color: white;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .accordionHeader h1 {\r\n    margin: 0px;\r\n    padding: 1vw;\r\n    font-size: 1.5vw;\r\n    width: 100%;\r\n    float: left;\r\n  }\r\n\r\n  .accordionHeader a {\r\n    float: right;\r\n  }\r\n\r\n  .accordionBody p {\r\n    margin: 0px;\r\n    padding-top: 0.5vw;\r\n    padding-bottom: 1vw;\r\n    padding-left: 1vw;\r\n    padding-right: 1vw;\r\n    font-size: 1vw;\r\n    width: 100%;\r\n    line-height: 1.2vw;\r\n  }\r\n}\r\n.bg {\r\n  background-image: url(\"../../../../assets/img/layout/student-bg.svg\");\r\n  background-repeat: no-repeat;\r\n  background-color: #f0f6f9;\r\n  background-position-y: bottom;\r\n  padding-bottom: 5vw;\r\n}\r\n\r\nion-content {\r\n  --ion-background-color: #fff;\r\n}\r\n.content {\r\n  background-color: white;\r\n  background-image: url(\"../../../../assets/img/layout/student-bg-bottom.svg\");\r\n  background-repeat: no-repeat;\r\n  background-position: center bottom;\r\n  border-top-left-radius: 1vw;\r\n  border-top-right-radius: 1vw;\r\n  margin-top: -1vw;\r\n  min-height: 100vh;\r\n}\r\n\r\n.toDoListTitle {\r\n  color: #0038a8;\r\n  font-family: \"Otomanopee One\", sans-serif;\r\n}\r\n\r\n.ion-padding-bottom {\r\n  padding-bottom: 200px;\r\n}\r\n\r\n.backCaption {\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.reloadBtn {\r\n  text-decoration: none;\r\n  float: right;\r\n}\r\n\r\n.nextTopic {\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  float: right;\r\n  text-align: right;\r\n}\r\n\r\n.prevTopic {\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  float: left;\r\n  text-align: left;\r\n}\r\n\r\nh2 {\r\n  font-family: \"Otomanopee One\", sans-serif;\r\n}\r\n\r\nh3 {\r\n  color: #5e5d59;\r\n  font-family: \"Otomanopee One\", sans-serif;\r\n}\r\n\r\nhr {\r\n  margin-top: 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 0;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n// ===========================================================================\r\n// Global responsive layout for the topic / video player view.\r\n// Ensures the video players, lesson content, navigation buttons and to-do\r\n// card scale cleanly from small phones up to large desktops.\r\n// ===========================================================================\r\n\r\n// Vimeo embed: the Vimeo SDK injects a fixed-width iframe. Force it to be fluid\r\n// so it never overflows the content column on any screen size.\r\n#myVideo {\r\n  width: 100%;\r\n  max-width: 100%;\r\n\r\n  iframe {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    aspect-ratio: 16 / 9;\r\n    height: auto !important;\r\n    border-radius: 8px;\r\n    display: block;\r\n  }\r\n}\r\n\r\n// Native (Mux / Bunny) player keeps a consistent aspect ratio and never\r\n// overflows horizontally.\r\n.native-video-wrap {\r\n  video#nativeVideoPlayer {\r\n    aspect-ratio: 16 / 9;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n// Lesson HTML coming from the CMS can contain wide images / iframes / tables.\r\n// Constrain them so the layout never breaks out on mobile.\r\n[innerHTML],\r\n.content {\r\n  img,\r\n  iframe,\r\n  video,\r\n  table {\r\n    max-width: 100%;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n// Topic navigation buttons (prev / next) — wrap and stay full width friendly\r\n// on small screens, inline on larger ones.\r\nion-button {\r\n  --border-radius: 8px;\r\n}\r\n\r\n// Prev/Next topic navigation: Prev on the left, Next on the right.\r\n// On wider screens they sit inline (space-between); on phones they stack and\r\n// each fills the full row width.\r\n.navigation-buttons {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  width: 100%;\r\n\r\n  .nav-btn {\r\n    margin: 0;\r\n  }\r\n\r\n  // Push the Next button to the right even when Prev is absent.\r\n  .nav-btn-next {\r\n    margin-left: auto;\r\n  }\r\n}\r\n\r\n// Phones\r\n@media (max-width: 575px) {\r\n  .content ion-grid {\r\n    padding-left: 6px;\r\n    padding-right: 6px;\r\n  }\r\n\r\n  // Prev/Next topic buttons stack and fill the row neatly.\r\n  .navigation-buttons {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n\r\n    .nav-btn {\r\n      width: 100%;\r\n      margin-left: 0;\r\n    }\r\n  }\r\n\r\n  // To-do card spacing\r\n  ion-card.ion-padding {\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n  }\r\n\r\n  h1 {\r\n    word-break: break-word;\r\n  }\r\n}\r\n\r\n// Tablets and up: keep the player and content readable and centered.\r\n@media (min-width: 768px) {\r\n  #myVideo iframe,\r\n  .native-video-wrap video#nativeVideoPlayer {\r\n    max-width: 720px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n// Large desktops: cap the media width so it doesn't stretch uncomfortably wide.\r\n@media (min-width: 1200px) {\r\n  #myVideo iframe,\r\n  .native-video-wrap video#nativeVideoPlayer {\r\n    max-width: 820px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
